import { CrossMarketRoute } from '@/catalog/types/cross-market-route';
import { ShippingFeeBreakdown } from '@/catalog/types/shipping-fee-breakdown';
import CrossMarketContent from './cross-market-content';
import DestinationFeeContent from './destination-fee-content';

interface ShippingDetailsContentProps {
  shippingFeeBreakdown?: ShippingFeeBreakdown;
  crossMarketRoute?: CrossMarketRoute;
}

export default function ShippingDetailsContent({
  shippingFeeBreakdown,
  crossMarketRoute,
}: ShippingDetailsContentProps) {
  return (
    <div className="flex w-fit flex-col items-center justify-center gap-[24px] p-[16px]">
      <DestinationFeeContent shippingFeeBreakdown={shippingFeeBreakdown} />
      <CrossMarketContent
        shippingFeeBreakdown={shippingFeeBreakdown}
        crossMarketRoute={crossMarketRoute}
      />
    </div>
  );
}
